import LandingView from '../../views/LandingView.vue';

export default [
  {
    path: '/profile',
    name: 'profile',
    component: LandingView,
    meta: {
      requiresAuth: true 
    }
  },
   {
    path: '/',
    name: 'Home',
    component: LandingView,
    meta: {
      requiresAuth: true 
    }
  }
];
